import {isLoggedIn} from "src/utilities/utilityFunctions";
import {obtainMediaTypes} from "src/services/gameTime/ApiServices";
import store from 'src/store';
import {updateAppSettings} from "src/actions/foundationActions";
import {updateCurrentActivityData} from "src/actions/gameTime";
import {updateGameTime} from "src/actions/gameTime";
import {updateUser} from "src/actions/permissionsActions";
import {addTabGroup} from "src/actions/foundationActions";
import {createTabGroupObject} from "../../../datamodels/foundation";

export const processTokenData = () =>{
    let storeData = store.getState();
    if(storeData.appSettings.tokenData?.hasOwnProperty("appSettings")){
        store.dispatch(updateAppSettings(Object.assign({},storeData.appSettings.tokenData.appSettings)))
    }

    if(storeData.appSettings.tokenData?.hasOwnProperty("currentActivityData")){
        store.dispatch(updateCurrentActivityData(Object.assign({},storeData.appSettings.tokenData.currentActivityData)))
    }

    if(storeData.appSettings.tokenData?.hasOwnProperty("gameTime")){
        store.dispatch(updateGameTime(Object.assign({},storeData.appSettings.tokenData.gameTime)))
    }

    if(storeData.appSettings.tokenData?.hasOwnProperty("user")){
        store.dispatch(updateUser(Object.assign({},storeData.appSettings.tokenData.user)))
    }
    /*
    let tokenData = Object.assign({},props.appSettings.tokenData);
    if(tokenData.appSettings){
        props.updateAppSettings(tokenData.appSettings);
    }
    if(tokenData.gameTime){
        props.updateGameTime({...tokenData.gameTime});
    }
    if(tokenData.currentActivityData){
        props.updateCurrentActivityData(Object.assign({},tokenData.currentActivityData))
    }
    if(tokenData.user){
        let person=Object.assign({},lowerCaseKeys(tokenData.user));
        person.isLoggedIn=true;
        props.updateUser(person);
    }

    //console.dir(tokenData)
console.dir(store.getState().appSettings.tokenData);
     */

};

export const currMainMod = () => {
    let storeData = store.getState();
    return storeData.appSettings.appMainModuleName
        ? storeData.appSettings.appMainModuleName
        : isLoggedIn()
            ? storeData.appSettings.defaultLoggedInModule
            : storeData.appSettings.defaultModule
};

export const prep = (props) =>{
    obtainMediaTypes(props);
    processTokenData(props);
};

/*
export const moduleShow = (props,height) => {
    height = height ? height : props.height;
    return props.dataStore.appMainModule ? <props.dataStore.appMainModule height={height} /> : <span id={"defaultWelcome"}>Welcome</span>;};
*/
export const mainHeight = (props) => {
    return (store.getState().gameTime.hideTopNav
            ? props.height
            : document.getElementById("mainContent") && document.getElementById("mainContent").parentElement && document.getElementById("utilityNav")
                ? props.appSettings.visibleHeight  - document.getElementById("utilityNav").offsetHeight
                : "500%"
    )};


